// extracted by mini-css-extract-plugin
export default {"host":"style_host__CZmkj","table":"style_table__wwAYy","body":"style_body__JlYSL"};